import * as React from "react";
import { forwardRef } from "react";
const SvgShare = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" clipRule="evenodd" d="M1 21.8988C3.6912 18.2096 6.08107 16.1162 8.16958 15.6186C10.2581 15.121 12.2466 15.0458 14.135 15.393V22L23 11.2192L14.135 1V7.27962C10.6433 7.31062 7.67491 8.71738 5.22977 11.5C2.78458 14.2826 1.37471 17.7489 1 21.8988Z" fill="#CCCCCC" /></svg>;
const ForwardRef = forwardRef(SvgShare);
export { ForwardRef as ReactComponent };